import { SxProps } from '@mui/material';
import {
  StyledSwitch as Switch,
  Tooltip,
  IconButton,
  Icons,
  Stack,
  Text,
} from '@/theme/index';

interface ExactMatchToggleProps {
  checked: boolean;
  setChecked?: (value: boolean) => void;
  label: string;
  tooltip?: string;
  reverseOrder?: boolean;
  stackStyles?: SxProps;
  switchStyles?: SxProps;
  tooltipStart?: boolean;
  className?: string;
}

export const SwitchLabel: React.FC<ExactMatchToggleProps> = ({
  checked,
  setChecked,
  label,
  tooltip,
  reverseOrder,
  stackStyles,
  switchStyles,
  tooltipStart,
  className,
}) => {
  return (
    <Stack direction="row" alignItems="center" sx={stackStyles} spacing={1}>
      {!reverseOrder && <Text lineHeight={1.2}>{label}</Text>}
      {tooltip && (
        <Tooltip title={tooltip} color="primary">
          <IconButton>
            <Icons.Info sx={{ fontSize: '1.25rem' }} />
          </IconButton>
        </Tooltip>
      )}
      {!tooltipStart && setChecked && (
        <Switch
          checked={checked}
          className={className}
          onChange={() => setChecked(!checked)}
          sx={switchStyles}
        />
      )}
      {reverseOrder && <Text lineHeight={1.2}>{label}</Text>}
      {tooltipStart && setChecked && (
        <Switch
          checked={checked}
          className={className}
          onChange={() => setChecked(!checked)}
          sx={switchStyles}
        />
      )}
    </Stack>
  );
};
